export const environment = {
  production: false,
  apiUrl: 'api',
  plannerViewRefreshTimeoutInSecs: 30,
};
